import React, { useState } from 'react';
import './BlurredGate.sass';

const BlurredGate = ({ children, userType }) => {
  const [loading, setLoading] = useState(false);

  const upgradeLabel = userType === 'host'
    ? 'Upgrade to All Access to unlock collaboration, messaging, and more.'
    : 'Upgrade to All Access for itineraries, messaging, exclusive deals, and more.';

  const handleUpgrade = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const email = localStorage.getItem('postaway_email') || '';

      if (userType === 'host') {
        window.location.href = `/host/checkout${email ? `?email=${encodeURIComponent(email)}` : ''}`;
        return;
      }

      if (!email) {
        window.location.href = '/traveler-signup';
        return;
      }

      const res = await fetch('/api/traveler/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();

      if (data.ok && data.url) {
        window.location.href = data.url;
      } else {
        window.location.href = '/traveler-signup';
      }
    } catch (_) {
      window.location.href = userType === 'host' ? '/host/checkout' : '/traveler-signup';
    }
  };

  return (
    <div className="blurred-gate-wrapper">
      <div className="blurred-gate-content">
        {children}
      </div>
      <div className="blurred-gate-overlay">
        <div className="blurred-gate-prompt">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#0f084b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <h3 className="blurred-gate-title">All Access Members Only</h3>
          <p className="blurred-gate-description">{upgradeLabel}</p>
          <button
            type="button"
            className="blurred-gate-button"
            onClick={handleUpgrade}
            disabled={loading}
          >
            {loading ? 'Redirecting...' : 'Upgrade Now'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlurredGate;
